<sl-input 
        ngDefaultControl
        [name]="key"
        [label]="props.label | htmlDecode"
        [type]="props['type']"
        [shoelaceReadonly]="props.readonly"
        [disabled]="props.disabled || false" 
        [required]="props.required || false" 
        [placeholder]="props.placeholder"
        [formControl]="formControl" 
        [formlyAttributes]="field"
        [passwordToggle]="props['toggle']"
        [value]="props['defaultValue']"
        [helpText]="props['helpText']">
</sl-input>